onDomReady(() => {
   $$('.patrolItems').addEvent('click:relay(.revisionActionBox a)', function (ev) {
      let a = $(this);
      let buttonGroup = this.parentNode;
      let itemCount = a.get('data-accept-count') || a.get('data-deny-count');
      ev.stop();

      // Disable buttons, so user doesn't double-submit.
      disableButtons(buttonGroup);

      if (
         itemCount > 1 &&
         !confirm(
            'This action will be applied to ' +
               itemCount +
               ' revisions.\n\nAre you sure you want to continue?'
         )
      ) {
         enableButtons(buttonGroup);
         return;
      }
      performAction(a.get('href'), a.get('edit-href'));
   });

   $$('.js-toggle-selected').addEvent('click', function (ev) {
      let isSelected = this.hasClass('selected');
      $$('.js-toggle-target').removeClass('toggle-open');
      $$('.js-toggle-selected').removeClass('selected');

      let target = this.getParent().getElement('.js-toggle-target');
      target.toggleClass('toggle-open', !isSelected);
      this.toggleClass('selected', !isSelected);
   });

   function performAction(href, editUrl) {
      new Request.API_2_0(href, { method: 'POST' })
         .send()
         .then(response => {
            if (editUrl) {
               window.location = editUrl;
            } else {
               window.location.reload();
            }
         })
         .catch(error => {
            alert(error);
         });
   }

   function disableButtons(buttonGroup) {
      buttonGroup.getChildren().forEach(el => {
         el.setAttribute('disabled', true);
      });
   }

   function enableButtons(buttonGroup) {
      buttonGroup.getChildren().forEach(el => {
         el.removeAttribute('disabled');
      });
   }
});
